import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getFolder } from '../lib/data';
import { ContainerView } from '../components/ContainerView';
import type { Folder } from '../lib/types';
import { Spinner } from '../components/ui';

export default function FolderPage() {
  const { id } = useParams();
  const [folder, setFolder] = useState<Folder | null | undefined>(undefined);

  useEffect(() => {
    if (id) getFolder(id).then(setFolder).catch(() => setFolder(null));
  }, [id]);

  if (folder === undefined) return <Spinner label="Loading…" />;
  if (!folder) return <p className="text-slate-500">Folder not found.</p>;

  return (
    <div>
      <div className="mb-4 flex items-center gap-2 text-sm text-slate-500">
        <Link to="/" className="hover:text-slate-700">
          My Files
        </Link>
        <span>/</span>
        <span className="font-medium text-slate-800">{folder.name}</span>
      </div>
      <ContainerView ownerId={folder.owner_id} folderId={folder.id} />
    </div>
  );
}
